export const inventoryDigitalMovementsTypes = {
  HANDLE_DIGITAL_MOV_INPUTS: 'HANDLE_DIGITAL_MOV_INPUTS',
  GET_INVENTORIES_DIGITAL_MOV: 'GET_INVENTORIES_DIGITAL_MOV',
  DIGITAL_UPDATE_ACTION: 'DIGITAL_UPDATE_ACTION',
};
